<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("usersshift", 2) }}
      </div>
      <router-link class="btn-blue" to="user-shifts"
        >{{ $tc("usersshift", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div
            v-if="userInfo.cinema_id !== 0"
            class="dropdown-curve-container pr-28px"
          >
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">
              {{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :disabled="isRoleID"
              :text="selectedCinema"
              v-model="selectedCinema"
              variant="dropdown-curve"
              class="w-100"
              name="selectcinema-1"
              id="selectcinema-1"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in Cinemas"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0">{{
              messagecinema
            }}</span>
          </p>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container pr-28px">
            <label
              :class="selected.Concession.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('concession', 1) }}</label>
            <div class="dropdown-curve-container">
              <b-dropdown :text="selected.Concession" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(concession, concessionIndex) in Concessions"
                  :key="concessionIndex"
                  @click="onSelectConcession(concession)"
                  name="selectconcession"
                  id="selectconcession"
                >{{ concession.cl_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>-->

        <!-- SELECT STORE  -->
        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container pr-28px">
            <label :class="selectedStoreLevel.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("store", 1) }}</label
            >
            <b-dropdown
              :text="selectedStoreLevel"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Store"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchStore()"
                  v-on:keydown="onSearchStore()"
                  v-on:search="onSearchStore()"
                  v-model="searchStore"
                />
              </div>
              <b-dropdown-item
                v-for="(Item, ItemIndex) in storeManagementsLevels"
                :key="ItemIndex"
                v-on:click="onSelectStore(Item)"
                >{{ Item.sm_store_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span v-if="submitted && users_shifts.sm_id.length == 0"
              >Please Select Store.</span
            >
          </p>
        </div> -->

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div
            v-if="userInfo.cinema_id !== 0"
            class="dropdown-curve-container pr-28px"
          >
            <label :class="selectedUser.length > 0 ? 'shift-up' : ''">
              {{ $tc("user", 1) }}</label
            >
            <b-dropdown
              :text="selectedUser"
              variant="dropdown-curve"
              class="w-100"
              name="selectuser"
              id="selectuser"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search User"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchUser()"
                  v-on:keydown="onSearchUser()"
                  v-on:search="onSearchUser()"
                  v-model="searchUser"
                />
              </div>
              <b-dropdown-item
                v-for="(user, userIndex) in Users"
                :key="userIndex"
                @click="onSelectUser($event, user)"
                >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <p class="error_message">
            <span v-if="submitted && selectedUser.length == 0">{{
              messageuser
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div
            v-if="userInfo.cinema_id !== 0"
            class="dropdown-curve-container pr-28px"
          >
            <label :class="selectedShift.length > 0 ? 'shift-up' : ''">
              {{ $tc("shift", 1) }}</label
            >
            <b-dropdown
              :text="selectedShift"
              variant="dropdown-curve"
              class="w-100"
              name="selectshift"
              id="selectshift"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Shift"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchShift()"
                  v-on:keydown="onSearchShift()"
                  v-on:search="onSearchShift()"
                  v-model="searchShift"
                />
              </div>
              <b-dropdown-item
                v-for="(shift, shiftIndex) in Shifts"
                :key="shiftIndex"
                v-on:click="onSelectShift($event, shift)"
                >{{ shift.shift_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <p class="error_message">
            <span v-if="submitted && selectedShift.length == 0">{{
              messageshift
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker" style="width: 356px">
                <button
                  class="btn-clearDate"
                  v-if="users_shifts.us_start_date"
                  v-on:click="clear_us_start_date()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="users_shifts.us_start_date"
                  name="shiftstart-1"
                  id="shiftstart-1"
                  :typeable="true"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="users_shifts.us_start_date ? 'active' : ''"
                  >{{ $tc("shift", 1) }} {{ $t("start") }}
                  {{ $t("date") }}</label
                >
              </div>
              <p class="error_message">
                <span v-if="submitted && users_shifts.us_start_date === ''"
                  >Please enter shift start date</span
                >
              </p>
            </div>
            <!-- <Tooltip :title="$t('us_start_date')" /> -->
          </div>
          <p class="error_message"></p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker" style="width: 356px">
                <button
                  class="btn-clearDate"
                  v-if="users_shifts.us_end_date"
                  v-on:click="clear_us_end_date()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="users_shifts.us_end_date"
                  name="shiftend-1"
                  id="shiftend-1"
                  :typeable="true"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="users_shifts.us_end_date ? 'active' : ''"
                  >{{ $tc("shift", 1) }} {{ $t("end") }} {{ $t("date") }}</label
                >
              </div>
              <p class="error_message">
                <span v-if="submitted && users_shifts.us_end_date === ''"
                  >Please enter shift end date</span
                >
              </p>
            </div>
            <!-- <Tooltip :title="$t('us_end_date')" /> -->
          </div>
          <p></p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="users_shifts.us_is_active"
              name="check-button"
              switch
              class="j-checkbox ml-2 mb-0"
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="user-shifts"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import Shifts from "@/helper/formJSONMaster/Shifts";

export default {
  data() {
    return {
      UsersCopy: [],
      searchUser: "",
      btenable: false,
      selected: {
        Concession: "",
      },
      messagecinema: "Please Select Cinema.",
      messageuser: "Please Select User.",
      messageshift: "Please Select Shift",
      users_shifts: {
        cinema_id: "",
        concession_level_id: "",
        sm_id: "",
        user_id: "",
        shift_id: "",
        us_start_date: "",
        us_end_date: "",
        us_is_active: "Y",
      },
      DatePickerFormat: "dd D yyyy",
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      isRoleID: true,
      Cinemas: [],
      Concessions: [],
      Users: [],
      Shifts: [],
      selectedCinema: "",
      selectedUser: "",
      selectedShift: "",
      userInfo: {},
      Shifts: Shifts.ms_shifts,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Shifts.Methods,

      storeManagementsLevels: [],
      selectedStoreLevel: "",
      // sm_id: ""
      CinemasCopy: [],
      searchCinema: "",
      storeManagementsLevelsCopy: [],
      searchStore: "",
      ShiftsCopy: [],
      searchShift: "",
    };
  },
  mounted() {
    this.userInfo = this.secureStore.get("USINFO");
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(this.userInfo.cinema_id);
    this.getShiftsList();
    if (this.userInfo.cinema_id === null) {
      this.getUsersList();
    }
  },
  methods: {
    onSearchUser: function () {
      if (this.searchUser && this.searchUser.length > 0) {
        this.Users = this.UsersCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.first_name.toLowerCase().includes(this.searchUser.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Users = this.UsersCopy;
      }
    },
    onSearchStore: function () {
      if (this.searchStore && this.searchStore.length > 0) {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy.filter(
          (x) => {
            // let full_name = `${x.first_name} ${x.last_name}`
            if (
              x.sm_store_name
                .toLowerCase()
                .includes(this.searchStore.toLowerCase())
              // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy;
      }
    },
    onSearchShift: function () {
      if (this.searchShift && this.searchShift.length > 0) {
        this.Shifts = this.ShiftsCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.shift_name.toLowerCase().includes(this.searchShift.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Shifts = this.ShiftsCopy;
      }
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    clear_us_start_date() {
      this.users_shifts.us_start_date = "";
    },
    clear_us_end_date() {
      this.users_shifts.us_end_date = "";
    },
    getCinemas: function (cine_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      // let body = {
      //   activekey: "cine_is_active"
      // };
      // MasterService.GlobalRequest(body)

      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;

                // this.getUsersList(x.cine_id);

                // // this.getConcessionLevelList(x.cine_id);
                // this.getStoreManagementList(x.cine_id);
                this.onSelectCinema(null, x);
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getStoreManagementList(cinema_id) {
      this.storeManagementsLevels = [];
      this.selectedStoreLevel = "";
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeManagementsLevels = data.Records;
            this.storeManagementsLevelsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectStore: function (store) {
      this.selectedStoreLevel = store.sm_store_name;
      this.users_shifts.sm_id = store.sm_id;
    },
    getConcessionLevelList: function (cinema_id) {
      this.Concessions = [];
      let payload = {
        tableName: "ms_concession_levels",
        cinema_id: cinema_id,
        cl_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          // console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.Concessions = data.Records;
          } else {
            // Show Error Message:
            console.log(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log(error);
        });
    },
    onSelectConcession: function (concession) {
      this.selected.Concession = concession.cl_name;
      this.users_shifts.concession_level_id = concession.cl_id;
    },

    getShiftsList: function () {
      this.Shifts = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_shifts",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            data.Records = data.Records.filter((x) => {
              return x.shift_is_active;
            });
            this.Shifts = data.Records;
            this.ShiftsCopy = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getUsersList: function (cinema_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "users"
      // });
      // if (cinema_id) {
      //   body[cinema_id] = cinema_id;
      // }
      MasterService.GetUsers({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;
            this.UsersCopy = data.Records;
            this.Users = this.Users.filter((singleRole) => {
              // console.log('singleRole :', singleRole.role_id != 2);
              if (singleRole.role_id == 4 || singleRole.role_id == 8) {
                return singleRole;
              }
            });
            this.UsersCopy = this.UsersCopy.filter((singleRole) => {
              // console.log('singleRole :', singleRole.role_id != 2);
              if (singleRole.role_id == 4 || singleRole.role_id == 8) {
                return singleRole;
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onSelectCinema: function (event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.getUsersList(cinema.cine_id);
      // this.getStoreManagementList(cinema.cine_id);
      // this.getConcessionLevelList(cinema.cine_id);
      this.users_shifts.cinema_id = cinema.cine_id;
    },
    onSelectUser: function (event, user) {
      this.selectedUser = user.first_name + " " + user.last_name;
      this.users_shifts.user_id = user.user_id;
      this.searchUser = "";
      this.onSearchUser();
    },
    onSelectShift: function (event, shift) {
      this.selectedShift = shift.shift_name;
      this.users_shifts.shift_id = shift.shift_id;
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.submitted = false;
      this.users_shifts = {
        user_id: "",
        shift_id: "",
        sm_id: "",
        us_start_date: "",
        us_end_date: "",
        us_is_active: true,
      };
      (this.selectedCinema = ""),
        (this.selectedUser = ""),
        (this.selectedStoreLevel = ""),
        (this.selectedShift = "");
    },
    handleSubmit(flag) {
      this.submitted = true;

      // var a = this.users_shifts.us_start_date;
      // var b = this.users_shifts.us_end_date;
      // // console.log(a);

      // if (
      //   (this.selectedCinema != "Select Cinema") &
      //   (this.selectedUser != "Select User") &
      //   (this.selectedShift != "Select Shift") &
      //   (a != "") &
      //   (b != "")
      // ) {
      // console.log("actuall",users_shifts.us_start_date);

      const { cinema_id, user_id, shift_id, us_start_date, us_end_date } =
        this.users_shifts;

      if (
        !cinema_id ||
        !user_id ||
        !shift_id ||
        !us_start_date ||
        !us_end_date
      ) {
        return;
      }

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          let body = {
            ...this.users_shifts,
          };
          MasterService.AddUserShifts(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.resetHandler();

                if (flag) {
                  this.$router.push({
                    path: "/cinema-manager/user-shifts",
                  });
                }
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/UsershiftsComponents/addUserShifts.vue